import { actionTypes } from '../../types';

// Action request
export const createBrandByAgency = (payload, callback) => ({
    type: actionTypes.CREATE_BRAND_BY_AGENCY_REQUEST,
    payload,
    callback
});

// Action success
export const createBrandByAgencySuccess = (payload) => ({
    type: actionTypes.CREATE_BRAND_BY_AGENCY_SUCCESS,
    payload,
});

// Action failure
export const createBrandByAgencyFailure = (payload) => ({
    type: actionTypes.CREATE_BRAND_BY_AGENCY_FAILURE,
    payload,
});

// Action reset status
export const createBrandByAgencyReset = () => ({
    type: actionTypes.CREATE_BRAND_BY_AGENCY_RESET,
});

// Action reset all reducer
export const createBrandByAgencyResetAll = () => ({
    type: actionTypes.CREATE_BRAND_BY_AGENCY_RESET_ALL,
});
